(function() {
	'use strict';

	angular.module('investPlusApp').config(stateConfig);

	stateConfig.$inject = [ '$stateProvider', 'GLOBAL_URL', '$base64',
			'$urlRouterProvider' ];

	function stateConfig($stateProvider, GLOBAL_URL, $base64,
			$urlRouterProvider) {
		$urlRouterProvider.otherwise("/investment-plus");
		$stateProvider
				.state(
						'investment-plus',
						{
							url : '/investment-plus/:txnId/:taskId',
							data : {
								pageTitle : 'Đầu tư thêm'
							},
							params : {
								txnId : {
									squash : true,
									value : null
								},
								taskId : {
									squash : true,
									value : null
								}
							},
							views : {
								'content@' : {
									// templateUrl : GLOBAL_URL + 'partial?uri=ga/investment-plus/layouts/investment-plus',
									templateUrl : GLOBAL_URL + 'partial?uri=ga/pulse/pulse',
									controller : 'InvestPlusController',
									controllerAs : 'investPlusCtr'
								}
							}
						})
	}
})();
